import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { Router } from 'react-router-dom';
import PropTypes from 'prop-types';

import uiTheme from './app.theme';
import { theme, getTheme2 } from './app.theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Main from './main';
import Login from './login';
import ResetPassword from './resetpassword';
import Signup from './signup';
import ForgotPassword from './login/forgot-password';
import AccountActivated from './activateaccount/accountactivated';
import ActivationFailed from './activateaccount/activationfailed';
import SetPassword from './activateaccount/setpassword.container';
import Landingpage from './landingpage';
import Navigator from './navigator';
import Impress from './impress';
import Footer from './footer';
import Notification from './main/notification';
import ENV from '../run-config';
import CookieBanner from 'react-cookie-banner';
import CollectiveApplication from './collective-application';
import ExternalLogin from './external_login';
import PlatformLogin from './platform-startscreen/login';
import PlatformSignup from './platform-startscreen/signup';
import publicRoutes from './util/publicRoutes';

// const publicRoutes = [
//   '/login',
//   '/signup',
//   '/resetpassword',
//   '/setpassword',
//   '/',
//   '/impressum',
//   '/forgotpassword',
//   '/accountactivated',
//   '/activationfailed',
//   '/benutzerregistrierung',
//   '/externallogin',
// ];

let landingpage = ENV.hasLandingpage ? Landingpage : Login;
if (ENV.isPlatformSolution) landingpage = PlatformLogin;
const SignupPage = ENV.isPlatformSolution ? PlatformSignup : Signup;

class App extends Component {

  componentWillMount() {
    this.props.loadConfig();
  }

  componentDidMount() {
    document.title = ENV.title;

    window.login = this.props.setAccessToken;
    if (window.accessToken) {
      this.props.setAccessToken(window.accessToken);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (!nextProps.loggedIn) {
      this
        .props
        .navigateToHome();
    }
  }

  renderCookieBanner() {
    const loggedIn = this.props.loggedIn;

    if (loggedIn) {
      return null;
    }

    return null;

    return (<CookieBanner
      message="Wir optimieren für Sie die Bedienbarkeit unserer Website und nutzen dafür Cookies, deren Anwendung Sie durch weitere Nutzung der Website zustimmen!"
      buttonMessage={'OK'}
      dismissOnScroll={false}
      cookie="user-has-accepted-cookies"
    />);
  }

  render() {
    const loggedIn = this.props.loggedIn;

    // HomeRoute prevents rendering of Main-Component when pathname is /Login
    const SecureHomeRoute = ({
      /* eslint-disable */
      component: Component,
      ...rest
      /* eslint-enable */
    }) => (
      <Route
        {...rest}
        render={(props) => {
          if (publicRoutes.indexOf(props.location.pathname.toLowerCase()) === -1) {
            if (!loggedIn) {
              return <Redirect to="/" />;
            }
            return <Component {...props} />;
          }
          return null;
        }}
      />
    );

    let mainClass = '';
    if (!loggedIn && ENV.brand == 'rlb') {
      mainClass = 'with-background';
    }


    return (
      <Router basename={'/'} history={this.props.history}>
        {/* <MuiThemeProviderOld muiTheme={uiTheme}> */}
        <MuiThemeProvider theme={uiTheme}>
          <div className={mainClass}>
            <div style={{ minHeight: 'calc(100vh - 60px)', overflow: 'hidden' }}>
              <Route path={'/impressum'} component={Impress} exact />
              <Route path="/" component={landingpage} exact />
              <Navigator history={this.props.history} key={this.props.loggedIn} />
              <Route path="/login" component={ENV.isPlatformSolution ? PlatformLogin : Login} exact />
              <Route path="/login-oevs"
                render={(props) => (
                  <Login brand="oevs" {...props} divisionId={8} userGroupId={15} />
                )} exact />
              <Route path="/resetpassword" component={ResetPassword} exact />
              <Route path="/setpassword" component={SetPassword} exact />
              <Route path="/signup" component={SignupPage} exact />
              <Route
                path="/signup-oevs"
                render={(props) => (
                  <SignupPage brand="oevs" {...props} divisionId={8} userGroupId={15} />
                )}
              />
              <Route path="/accountactivated" component={AccountActivated} exact />
              <Route path="/activationfailed" component={ActivationFailed} exact />
              <Route path="/forgotpassword" component={ForgotPassword} />

              <Route
                path="/forgotpassword-oevs"
                render={(props) => (
                  <ForgotPassword brand="oevs" />
                )}
              />
              <Route path="/benutzerregistrierung" component={CollectiveApplication} exact />
              <Route path="/externallogin" component={ExternalLogin} />
              <SecureHomeRoute path="/" component={Main} />
              <Notification />

            </div>
            <Footer onNavigate={this.props.navigateTo} history={this.props.history} />
            {this.renderCookieBanner()}
          </div>
        </MuiThemeProvider>
      </Router>
    );
  }
}

App.propTypes = {
  history: PropTypes.any.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  navigateToHome: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
  setAccessToken: PropTypes.func.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/app/app.js